module.exports = __webpack_public_path__ + "img/galaxy_green_print.e0b3d98f.png";